// 给报告页"整理标签"按钮配套的轮询 controller。
// 用户点按钮后启动，3 秒查一次后端 categorize_status；
// 收到 done:true 就把对应的 Turbo Frame 指向卡片 URL，让它自动刷新。
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    frameId: String,
    cardUrl: String,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    // 故意不在 connect 时自动启动 —— 等按钮点击后才开始
  }

  start() {
    if (this.timer) return
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      const data = await res.json()
      if (data.done) {
        clearInterval(this.timer)
        this.timer = null
        const frame = document.getElementById(this.frameIdValue)
        if (frame) {
          frame.src = this.cardUrlValue
          frame.reload()
        }
      }
    } catch (e) {
      // 网络抖一下不要紧，下一轮再试；让循环继续
    }
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
